export const submit = {
  onboardingSteps: [
    {
      key: 'managed_marketplace',
      status: 'empty',
      name: 'Managed/Marketplace',
      type: 'multi',
      selectedValue: [],
      number_of_sections: 2,
      current_section: 0,
      endEarly: true,
      cards: [
        {
          hero:
            'Based on your selections you’re able to choose from either service.',
          description: '',
          type: 'single',
          inner_cards: [
            {
              isSpecial: true,
              value: 'managed_marketplace',
            },
          ],
        },
        {
          hero: 'Congrats!',
          description:
            'You’ve been upgraded to our Managed Service at no extra cost to you!',
          type: 'single',
          inner_cards: [
            {
              isSpecial: true,
              value: 'management_way',
            },
          ],
        },
      ],
    },
    {
      key: 'budget',
      name: 'Budget',
      status: 'empty',
      type: 'single',
      hero: 'Pricing Calculator',
      description:
        'A key difference between us and other’s is our emphasis on quality, fair pricing, and unparalleled attention to detail. Given our commitment and your selections, we have selected the following range:',
      selectedValue: [],
      cards: [
        {
          isSpecial: true,
          value: 'pricing_calculator',
        },
      ],
    },
    {
      key: 'choose_freelancer',
      status: 'empty',
      name: 'Choose Freelancer',
      type: 'single',
      hero: 'Choose an editor to create your project!',
      selectedValue: [],
      cards: [
        {
          isSpecial: true,
          value: 'freelancer_chooser',
        },
      ],
    },
    {
      key: 'summary',
      status: 'empty',
      name: 'Summary',
      type: 'single',
      hero: 'Congrats, Your project is out for bid!',
      description: 'Check your email and your dashboard for updates.',
      selectedValue: [],
      cards: [
        {
          isSpecial: true,
          value: 'summary',
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/overviewSteps/submit.js